import React, {useState, useEffect} from 'react';
import { useNavigate, useParams  } from 'react-router-dom';
import {client} from "@/client"
import {setBearerToken} from "@/auth";

import {
  Page,
} from "@/components/layout"

export const Ql = () => {

  const navigate = useNavigate();
  const { param } = useParams();

  useEffect(() => {

    const processParam = async () => {

      //パラーメータの文字数は16文字固定
      if (!param || param?.length !== 16) {
        navigate("/login");
      }
      else {

        const loginId = param[0] + param[2] + param[4] + param[6] + param[8] + param[10] + param[12] + param[14];
        const loginCode = param[1] + param[3] + param[5] + param[7] + param[9] + param[11];

        //console.log(loginId);
        //console.log(loginCode);

        var sum = 0;
        for (const char of param.substring(0,13)) {
          //console.log(char);
          sum += parseInt(char, 10);
        }
        //console.log(param[14]);
        sum += parseInt(param[14], 10);
        sum = sum % 100;
      
        var ck = (parseInt(param[13], 10) * 10) + parseInt(param[15], 10);
        //console.log(sum);
        //console.log(ck);

        if (sum !== ck) {
          navigate("/login");
        } else {

          const resp = await client.login({
//            id: id,
            id: "",
            password: "",
            code: loginCode,
          })

          //console.log(resp.currentUser?.id ?? "");

          if ((!resp.error) && (resp.currentUser?.id === loginId)) {
            console.log("Succeeded to login");

            setBearerToken(resp.bearerToken)
            if (resp.currentUser?.optRole === "student") {
              navigate("/works")
            } else {
              navigate("/login");
            }

          } else {
            console.log("Failed to login");
            navigate("/login");
          }
        }
      }
    };
    processParam();

  },[param, navigate]);


  return <Page>
  </Page>
}



